// removed by extract-text-webpack-plugin
module.exports = {"vent":"etlHEFe_83KLTYslJ2v7W","ventOn":"_2h7Ex4BsU6nEObpR-XKpFv","ventOff":"_1D1unZ_W4shqwLVxiTuueK","ventAvar":"_3SROBbg_4aRZWYRAiLGUFQ","disabled":"_2Ht0CAq0iokjS6p_VyvekT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/Vent/style.css
// module id = 345
// module chunks = 0